import useLazyVideo from '../../../hooks/useLazyVideo';

interface LazyVideoProps {
  src: string;
  className?: string;
}

function LazyVideo({ src, className }: LazyVideoProps) {
  const videoRef = useLazyVideo('150px');
  return (
    <video
      ref={videoRef}
      src={src}
      loop
      muted
      playsInline
      preload="none"
      className={className}
    />
  );
}

export default function UrbanLifestyle() {
  const lifestyleItems = [
    {
      id: 1,
      src: 'https://storage.readdy-site.link/project_files/d45d6433-09d1-4f4c-94b0-3f34b93f0615/31830d31-7997-4583-8bf3-4d7ae1db43de_parkw.mp4?v=204f3a7eac106c3787a8ba6c139d7137',
      caption: 'STREET CULTURE',
    },
    {
      id: 2,
      src: 'https://storage.readdy-site.link/project_files/d45d6433-09d1-4f4c-94b0-3f34b93f0615/62d93005-d575-4812-93c9-51524b7c8294_parkade3.mp4?v=2de074a6d4191a8effc7fea62bc8c52a',
      caption: 'ENDLESS HORIZONS',
    },
    {
      id: 3,
      src: 'https://storage.readdy-site.link/project_files/d45d6433-09d1-4f4c-94b0-3f34b93f0615/9b5b60ad-bf92-48ba-a448-ca4cb778e07f_828ca489-ab44-479c-bca9-c479e753da66.mp4?v=3b79464111b08e3b98c032827cb05cb8',
      caption: 'BACK TO THE BEACH',
    },
    {
      id: 4,
      src: 'https://storage.readdy-site.link/project_files/d45d6433-09d1-4f4c-94b0-3f34b93f0615/4651ceb9-b4e5-437f-b396-49b249478594_IMG_9155.mp4?v=726799f3dd21e7805267233cd818a3e4',
      caption: 'PUSH LIMITS',
    },
  ];

  return (
    <section id="lifestyle" className="py-16 md:py-24 px-6 bg-zinc-950">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-6xl font-black mb-4 tracking-tight">LIVE ELECTRIC</h2>
          <p className="text-xl text-gray-400">More than a mobility solution. It&apos;s the ultimate life tool.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          {lifestyleItems.map((item) => (
            <div key={item.id} className="group cursor-pointer">
              <div className="relative overflow-hidden rounded-lg mb-4 w-full h-[500px]">
                <LazyVideo
                  src={item.src}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-black/40 group-hover:bg-black/20 transition-colors duration-300"></div>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-r from-teal-600 to-teal-500 rounded-2xl p-6 sm:p-8 md:p-12 text-center">
          <h3 className="text-2xl md:text-4xl font-black mb-3 md:mb-4 text-black">JOIN THE MOVEMENT</h3>
          <p className="text-sm md:text-lg mb-6 md:mb-8 text-black/80 max-w-2xl mx-auto">
            Be part of a community that&apos;s redefining personal mobility. Share your journeys, connect with fellow users, and discover new adventures.
          </p>
          <a
            href="https://www.instagram.com/ind_echairs/"
            target="_blank"
            rel="nofollow noreferrer"
            className="inline-block bg-black text-white px-10 py-4 rounded-full text-base font-bold hover:bg-zinc-900 transition-colors cursor-pointer whitespace-nowrap"
          >
            FOLLOW US
          </a>
        </div>
      </div>
    </section>
  );
}
